<template>
  <div class="content_box UBO" @click="isShowSearchType = false">
    <div class="el-carousel__item home_bg"></div>
    <div class="new-home-wrap">
      <Header :fontColor="'#603C2C'"></Header>
      <div class="new-home-search">
        <!-- <SearchCon></SearchCon> -->
        <div class="home_search_box">
          <div
            class="search_type"
            @click.stop="isShowSearchType = !isShowSearchType"
          >
            <span>{{ searchType }}</span>
            <i
              class="iconfont icon-jiantouxia"
              :class="{ open_search: isShowSearchType }"
            />
          </div>
          <div
            class="search_type_select"
            :class="{ search_type_select_show: isShowSearchType }"
          >
            <div
              class="search_type_select_list"
              :class="{ active: searchType == 'Company' }"
              @click.stop="choseSearchType('Company')"
            >
              {{ $t("Relationship.Company") }}
            </div>
            <div
              class="search_type_select_list"
              :class="{ active: searchType == 'Product' }"
              @click.stop="choseSearchType('Product')"
            >
              {{ $t("Relationship.Product") }}
            </div>
          </div>
          <el-input
            class="search_input"
            :placeholder="
              searchType == $t('Relationship.Company')
                ? $t('Relationship.Entercompanyname')
                : $t('Relationship.Enterproductkeywords')
            "
            @keyup.enter.native="searhUbo(searchKeyword)"
            v-model="searchKeyword"
          ></el-input>
          <div class="search_btn" @click.stop="searhUbo(searchKeyword)">
            <i class="iconfont icon-search" />
            {{ $t("Home.search") }}
          </div>
        </div>
      </div>
      <div class="new-home-search-text">
        {{ $t("Relationship.UltimateOwnershipGlobalCoverage") }}
      </div>
      <!-- 底部 -->
      <div class="new-home-bottom">
        <div class="new-home-title">{{ $t("Home.homeSeachTitle") }}</div>
        <div class="new-home-bottom-card">
          <div class="new-home-card-left UboBack">
            <img :src="ellipseImg" />
            <div
              class="slider-box"
              @click="goPage('https://www.csibizinfo.com/?Form=Csi')"
            >
              <div class="slider-con">
                <div
                  class="slider-item"
                  v-for="(item, index) in textList"
                  :key="index"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>
          <div class="new-home-card-middle">
            <div
              class="new-home-middle-img"
              :style="{ backgroundImage: 'url(' + middleImg + ')' }"
            ></div>
            <div
              class="new-home-middle-text"
              @click="goPage('https://www.csibizinfo.com/')"
            >
              {{ $t("Home.homeTitleDetail") }}
            </div>
          </div>
          <div class="new-home-card-right">
            <div class="new-home-right-img">
              <img :src="wechatImg" />
            </div>
            <div class="new-home-right-text">
              {{ $t("Home.phoneTitleDetail") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Login :loginAndCreatePop.sync="loginDialog"></Login>
    <!-- ubo提示弹窗 -->
    <el-dialog
      append-to-body
      title=""
      :visible.sync="uboDialogVisible"
      :before-close="
        () => {
          uboDialogVisible = false;
        }
      "
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      class="dialog_modal dialog_800"
      center
    >
      <div class="dialog_content">
        <div class="dialog_title_img">
          <img src="@/assets/images/ubo_icon.png" />
        </div>
        <div class="dialog_title_img_text">{{ $t("Relationship.SearchRelationship") }}</div>
        <div class="risk_desc">
          <span><span class="blod">{{ $t("Relationship.SearchRelationship") }} </span> {{ $t("Relationship.SearchRelationshipInfo") }}
          </span>
          <ul>
            <li>
              <span class="blod">{{ $t("Relationship.UltimateOwnershipControl") }}: </span>{{ $t("Relationship.UltimateOwnershipControlInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("Relationship.InvestmentParticipation") }}: </span>{{ $t("Relationship.InvestmentParticipationInfo") }}
            </li>
            <li>
              <span class="blod">{{ $t("Relationship.SupplyChainNetwork") }}: </span>{{ $t("Relationship.SupplyChainNetworkInfo") }}
            </li>
          </ul>
          <span>{{ $t("Relationship.Ourplatformempowers") }}
          </span>
        </div>
        <el-button class="risk_begin_btn" @click="uboDialogVisible = false"
          >{{ $t("Relationship.LetsBegin") }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Header from "@/views/newLayout/header.vue";
import SearchCon from "@/views/newLayout/searchCon.vue";
import Login from "@/components/login.vue";
export default {
  name: "UboIndex",
  components: { Header, SearchCon, Login },
  computed: {
    textList() {
      return [
        {
          title: this.$t("Home.BusinessIntelligence"),
        },
        {
          title: this.$t("Home.CompanyIdentityVerification"),
        },
        {
          title: this.$t("Home.KYCSolutions"),
        },
        {
          title: this.$t("Home.CompanyFinancialAnalysis"),
        },
        {
          title: this.$t("Home.CreditRatings"),
        },
        {
          title: this.$t("Home.CreditReports"),
        },
        {
          title: this.$t("Home.ESGRatings"),
        },
        {
          title: this.$t("Home.VendorScreening"),
        },
        {
          title: this.$t("Home.MarketResearch"),
        },
        {
          title: this.$t("Home.IndustryAnalysis"),
        },
        {
          title: this.$t("Home.BusinessAnalytics"),
        },
        {
          title: this.$t("Home.ImportExportData"),
        },
        {
          title: this.$t("Home.CompanyNews"),
        },
        {
          title: this.$t("Home.Sanctions"),
        },
        {
          title: this.$t("Home.SearchLeads"),
        },
        {
          title: this.$t("Home.BusinessIntelligence"),
        },
        {
          title: this.$t("Home.CompanyIdentityVerification"),
        },
        {
          title: this.$t("Home.KYCSolutions"),
        },
        {
          title: this.$t("Home.CompanyFinancialAnalysis"),
        },
        {
          title: this.$t("Home.CreditRatings"),
        },
        {
          title: this.$t("Home.CreditReports"),
        },
        {
          title: this.$t("Home.ESGRatings"),
        },
        {
          title: this.$t("Home.VendorScreening"),
        },
        {
          title: this.$t("Home.MarketResearch"),
        },
        {
          title: this.$t("Home.IndustryAnalysis"),
        },
        {
          title: this.$t("Home.BusinessAnalytics"),
        },
        {
          title: this.$t("Home.ImportExportData"),
        },
        {
          title: this.$t("Home.CompanyNews"),
        },
        {
          title: this.$t("Home.Sanctions"),
        },
        {
          title: this.$t("Home.SearchLeads"),
        },
      ];
    },
  },
  data() {
    return {
      uboDialogVisible: true,
      searchType: "Company",
      searchKeyword: "",
      isShowSearchType: false,
      loginDialog: false,
      offest: 38,
      ellipseImg: require("@/assets/images/newPage/ellipse.png"),
      middleImg: require("@/assets/images/newPage/home-center.jpg"),
      wechatImg: require("@/assets/images/newPage/wechat.png"),
    };
  },
  methods: {
    choseSearchType(val) {
      this.searchType = val;
      this.isShowSearchType = false;
      this.$refs.searchTypeRef;
    },
    // 检索
    searhUbo(val) {
      const token = localStorage.getItem("token");
      if (token) {
        if (this.searchKeyword == "" || this.searchKeyword == null) {
          this.$message({
            message:
              this.searchType == "Company"
                ? this.$t('Relationship.Entercompanyname')
                : this.$t('Relationship.Enterproductkeywords'),
            center: true,
            type: "error",
          });
          return;
        }

        this.$router.push({
          path: "/ubo/list",
          query: {
            keyword: val,
            selectKey: this.searchType,
          },
        });
      } else {
        this.loginDialog = true;
      }
    },
    goPage(value) {
      window.open(value, "_blank");
    },
    scrollInit() {
      if (document.body.clientWidth >= 1510) {
        this.offest = 38;
      } else {
        this.offest = 22;
      }
      const body = document.querySelector(".slider-box");
      if (body) {
        const bodyRect = body.getBoundingClientRect();

        const bodyCenterY = bodyRect.top + bodyRect.height / 2;
        document.querySelectorAll(".slider-item").forEach((li) => {
          const liRect = li.getBoundingClientRect();
          const liCenterY = liRect.top + liRect.height / 2 + this.offest;

          if (Math.abs(bodyCenterY - liCenterY) < liRect.height / 2) {
            li.classList.add("active");
          } else {
            li.classList.remove("active");
          }
        });
      }
    },
  },
  mounted() {
    setInterval(this.scrollInit, 100);
  },
  beforeDestroy() {
    clearInterval(this.scrollInit);
  },
};
</script>
<style scoped>
.home_search_box {
  width: 1000px;
  height: 70px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(42, 104, 142, 0.18);
  border-radius: 35px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.search_type {
  width: 210px;
  height: 70px;
  background: #ffffff;
  border-radius: 35px 0 0 35px;
  padding: 20px 0 20px 20px;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #1a2332;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
  position: relative;
}

.search_type span {
  flex: 1;
  text-align: left;
}

.search_type i {
  width: 30px;
  margin-right: 4px;
}

.search_type_select {
  position: absolute;
  top: 80px;
  left: 0;
  padding: 12px 0;
  width: 200px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: -1;
  opacity: 0;
  transform: perspective(300px) rotateX(-10deg);
  transform-origin: 50% 0;
  pointer-events: none;
  transition: all 0.3s ease-in-out;
}

.search_type_select_show {
  opacity: 1;
  z-index: 9;
  pointer-events: all;
  transform: rotateX(0deg);
}

.search_type_select_list {
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  font-size: 18px;
}

.search_type_select_list.active {
  background: #faefec;
  color: #b44818;
}

.search_input {
  flex: 1;
}

.search_input >>> .el-input__inner {
  height: 100%;
  border: none;
  padding-left: 20px;
  font-size: 18px;
  color: #1a2332;
}

.search_input >>> .el-input__inner::placeholder {
  font-size: 18px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}

.search_btn {
  position: relative;
  left: 1px;
  width: 150px;
  height: 70px;
  background: #603c2c;
  border-radius: 0px 35px 35px 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  line-height: 20px;
  font-style: normal;
  padding: 0 0 0 10px;
}

.search_btn i {
  font-size: 36px;
}

.risk_desc ul li:before {
  background: #b44818;
}
.risk_desc .blod {
  color: #b44818;
}

.risk_begin_btn {
  background: #603c2c;
}

.risk_begin_btn:hover {
  color: #fff;
}

.open_search {
  transform: rotate(180deg);
  transition: 0.1s;
}

.new-home-con {
  flex: 1;
  position: relative;
}

.new-home-con .el-carousel {
  height: 100%;
}

.new-home-con >>> .el-carousel__container {
  height: 100%;
}

.new-home-con >>> .el-carousel__item {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.new-home-con >>> .el-carousel__indicators--horizontal {
  display: flex;
  align-items: center;
  height: 8px;
  bottom: 3%;
}

.new-home-con >>> .el-carousel__indicator {
  padding: 0;
}

.new-home-con >>> .el-carousel__indicator:not(:last-child) {
  margin-right: 6px;
}

.new-home-con >>> .el-carousel__button {
  width: 8px;
  height: 8px;
  opacity: 1;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.51);
}

.new-home-con >>> .el-carousel__indicator.is-active .el-carousel__button {
  background: rgba(255, 255, 255, 1);
}

.new-home-con .new-home-wrap {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: calc(100vh - 7vh);
  z-index: 2;
}

.new-home-search-text {
  width: 100%;
  font-size: 18px;
  color: #ffffff;
  line-height: 30px;
  text-shadow: 0px 2px 2px rgba(35, 16, 7, 0.8);
  text-align: center;
  position: relative;
}

.new-home-bottom {
  position: absolute;
  bottom: 7vh;
  left: 50%;
  transform: translateX(-50%);
  width: 82.709%;
}

.new-home-title {
  width: calc(100% - 40px);
  height: 88px;
  margin: 0 auto;
  line-height: 88px;
  padding-left: 20px;
  font-size: 34px;
  color: #ffffff;
  text-shadow: 0px 2px 2px rgba(6, 59, 64, 0.5);
  background: RGB(83, 81, 69, 0.3);
  border-radius: 6px;

  backdrop-filter: blur(8px);
}

.new-home-bottom-card {
  display: flex;
  height: 352px;
  padding: 20px;
  background: #ffffff;
  border-radius: 12px;
}

.new-home-card-left,
.new-home-card-middle {
  flex: 1;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
}

.new-home-card-left {
  position: relative;
  padding-left: 50px;
  background: #1290c9;
}

.new-home-card-left img {
  position: absolute;
  top: 110px;
  left: 14px;
  width: 22px;
  height: 16px;
}

.new-home-card-left .slider-box {
  position: relative;
  height: 100%;
  overflow: hidden;
}

.new-home-card-left .slider-con {
  display: flex;
  flex-direction: column;
  /* 内容排列为竖直方向 */
  padding-top: 14px;
  animation: scrollTop 25s linear infinite;
  will-change: transform;
}

.dataService-bottom-card {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.dataService-bottom-card-li {
  width: 300px;
  height: 352px;
  background: linear-gradient(
    136deg,
    rgba(22, 197, 216, 0.1) 0.22%,
    rgba(3, 44, 61, 0.52) 100%
  );
  border-radius: 12px;
  border: 1px solid;
  border-image: linear-gradient(
      136deg,
      rgba(21, 250, 245, 1),
      rgba(17, 117, 144, 1)
    )
    1 1;
  backdrop-filter: blur(6px);
  margin-right: 22px;
}

.dataService-bottom-card-li:last-of-type {
  margin-right: 0;
}

.dataService-bottom-card-icon {
  width: 44px;
  height: 44px;
  margin: 40px auto 20px;
  background-color: #000000;
}

.dataService-bottom-card-title {
  text-align: center;
  height: 26px;
  font-family: Arial, Arial;
  font-weight: normal;
  font-size: 18px;
  color: #ffffff;
  line-height: 26px;
  text-align: center;
  font-style: normal;
  margin-bottom: 20px;
}

.dataService-bottom-card-text {
  padding: 0 20px;
  font-family: ArialMT;
  font-size: 18px;
  color: #ffffff;
  line-height: 28px;
  text-align: left;
  font-style: normal;
}

.dataService-bottom-card-text li::before {
  content: "";
  width: 6px;
  height: 6px;
  background: #ffffff;
  border-radius: 50%;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
}

@keyframes scrollTop {
  0% {
    transform: translateY(0);
    /* 初始位置 */
  }

  100% {
    transform: translateY(-47%);
  }
}

.new-home-card-left .slider-item {
  display: flex;
  align-items: center;
  height: 28px;
  line-height: 28px;
  font-weight: bold;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
  transition: 0.5s ease-in-out !important;
  cursor: pointer;
}

.new-home-card-left .slider-item.active {
  font-size: 24px;
  color: #ffffff;
}

.new-home-card-left .slider-item:not(:last-child) {
  margin-bottom: 2px;
}

.new-home-card-middle {
  position: relative;
  margin: 0 14px;
  background-position: left center;
  background-size: cover;
  overflow: hidden;
}

.new-home-middle-img {
  position: absolute;
  top: 0%;
  left: 50%;
  transform: translate3d(-42%, 0%, 0);
  max-width: none;
  width: 703px;
  height: 399px;
  background-position: center center;
  background-size: cover;
  /* will-change: transform; */
  animation: scrollImg 12s linear infinite alternate;
}

@keyframes scrollImg {
  0% {
    transform: translate3d(-42%, 0%, 0);
  }

  50% {
    transform: translate3d(-50%, 0%, 0);
  }

  100% {
    transform: translate3d(-58%, 0%, 0);
  }
}

.new-home-middle-text {
  position: absolute;
  left: 0;
  bottom: 0;
  padding: 30px 20px;
  font-weight: 400;
  font-size: 16px;
  color: #ffffff;
  line-height: 22px;
  text-align: justify;
  cursor: pointer;
}

.new-home-middle-text:hover {
  text-decoration: underline;
}

.new-home-card-right {
  width: 300px;
  padding: 40px 10px 0 10px;
  background: #f5f5f5;
  border-radius: 12px;
}

.new-home-right-img {
  width: 120px;
  height: 120px;
  padding: 3px;
  margin: 0 auto 16px auto;
  background: #ffffff;
}

.new-home-right-text {
  font-weight: 400;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: center;
}

.search_type::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 30px;
  background: #dddddd;
}

@media (max-width: 1920px) {
  .home_search_box {
    width: 750px;
    height: 50px;
    border-radius: 26px;
    margin-bottom: 22px;
  }

  .search_type {
    width: 160px;
    height: 50px;
    background: #ffffff;
    border-radius: 25px 0 0 25px;
    padding: 16px 0 16px 15px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_type i {
    width: auto;
    font-size: 16px;
    margin-right: 10px;
  }

  .search_type_select {
    position: absolute;
    top: 60px;
    left: 0;
    padding: 10px 0;
    width: 160px;
    gap: 10px;
  }

  .search_type_select_list {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
  }

  .search_type::after {
    height: 22px;
  }

  .search_input >>> .el-input__inner {
    padding: 0 10px;
    font-size: 14px;
  }

  .search_input >>> .el-input__inner::placeholder {
    font-size: 14px;
    line-height: 16px;
  }

  .search_btn {
    width: 110px;
    height: 50px;
    border-radius: 0px 25px 25px 0px;
    font-size: 14px;
    line-height: 16px;
  }

  .search_btn i {
    font-size: 26px;
    margin-right: 5px;
    margin-left: 1px;
  }

  .new-home-search-text {
    font-size: 14px;
    line-height: 20px;
  }

  .new-home-bottom {
    width: 1300px;
  }

  .new-home-title {
    width: calc(100% - 32px);
    height: 70px;
    line-height: 70px;
    padding-left: 16px;
    font-size: 28px;
    border-radius: 5px;
  }

  .new-home-bottom-card {
    height: 282px;
    padding: 16px;
    border-radius: 10px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 10px;
  }

  .new-home-card-left {
    padding-left: 40px;
  }

  .new-home-card-left img {
    top: 80px;
    left: 11px;
    width: 18px;
    height: 14px;
  }

  .new-home-card-left .slider-con {
    padding-top: 11px;
  }

  .new-home-card-left .slider-item {
    height: 24px;
    line-height: 24px;
    font-size: 14px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 20px;
  }

  .new-home-card-middle {
    margin: 0 12px;
  }

  .new-home-middle-img {
    width: 562px;
    height: 320px;
  }

  .new-home-middle-text {
    padding: 24px 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .new-home-card-right {
    width: 240px;
    padding: 32px 8px 0 8px;
    border-radius: 10px;
  }

  .new-home-right-img {
    width: 96px;
    height: 96px;
  }

  .new-home-right-text {
    font-size: 14px;
    line-height: 18px;
  }

  .risk_desc {
    line-height: 22px;
  }
}

.home_bg {
  background: url("../../assets/images/home_ubo.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center center;
}

.UboBack {
  background-color: #603c2c !important;
}

@media screen and (max-width: 1439px) {
  .new-home-bottom {
    width: 1100px;
  }

  .new-home-title {
    width: calc(100% - 28px);
    height: 60px;
    line-height: 60px;
    padding-left: 14px;
    font-size: 24px;
    border-radius: 4px;
  }

  .new-home-bottom-card {
    height: 246px;
    padding: 14px;
    border-radius: 8px;
  }

  .new-home-card-left,
  .new-home-card-middle {
    border-radius: 8px;
  }

  .new-home-card-left {
    padding-left: 35px;
  }

  .new-home-card-left img {
    top: 78px;
    left: 10px;
    width: 16px;
    height: 12px;
  }

  .new-home-card-left .slider-con {
    padding-top: 10px;
  }

  .new-home-card-left .slider-item {
    height: 20px;
    line-height: 20px;
    font-size: 12px;
  }

  .new-home-card-left .slider-item.active {
    font-size: 16px;
  }

  .new-home-card-middle {
    margin: 0 10px;
  }

  .new-home-middle-img {
    width: 492px;
    height: 280px;
  }

  .new-home-middle-text {
    padding: 20px 14px;
    font-size: 12px;
    line-height: 16px;
  }

  .new-home-card-right {
    width: 210px;
    padding: 28px 10px 0 7px;
    border-radius: 8px;
  }

  .new-home-right-img {
    width: 84px;
    height: 84px;
  }

  .new-home-right-text {
    font-size: 12px;
    line-height: 16px;
  }
}
</style>
